<template>
  <div>
    <v-row no-gutters>
      <v-col class="pa-2" cols="12">
        <v-btn :disabled="!selectedRows.length" class="btn-delete" outlined rounded @click="payGroup">
          <span class="fa fa-users ml-1"></span>
          پرداخت گروهی آگهی
        </v-btn>
      </v-col>

      <v-col class="pa-2" cols="12">
        <vue-table v-model="selectedRows" :data="data" :headers="headers" :loading.sync="loading" show-select
                   @change="onPaginate">
          <template v-slot:filters="{props, perPage}">
            <v-row no-gutters>
              <v-col class="pa-2" cols="12" lg="1" md="2">
                <v-select v-model="props.length" :items="perPage" class="rounded-lg" dense hide-details label="تعداد"
                          outlined/>
              </v-col>

              <v-col class="pa-2" cols="12" lg="3" md="4">
                <v-select v-model="props.provider" :items="items" :menu-props="{offsetY: true}" class="rounded-lg"
                          clearable dense hide-details label="فیلتر نوع آگهی" outlined/>
              </v-col>

              <v-col class="pa-2" cols="12" lg="3" md="4">
                <v-select v-model="props.auto_payments" :items="autoPayItems" :menu-props="{offsetY: true}"
                          class="rounded-lg"
                          clearable dense hide-details label="فیلتر پرداخت‌ها" outlined/>
              </v-col>

              <v-col class="pa-2" cols="12" lg="3" md="4">
                <v-text-field v-model="props.search" append-icon="mdi-magnify" class="rounded-lg" clearable dense
                              hide-details label="جستجو" outlined/>
              </v-col>
            </v-row>
          </template>

          <template v-slot:index="{item}">
            {{ (item.index + 1) + ((data.current_page - 1) * data.per_page) }}
          </template>

          <template v-slot:id={item}>
            <a v-if="!!item.advertise && !!item.advertise.data && !!item.advertise.data.token"
               :href="`https://divar.ir/v/${item.advertise.data.token}`" target="_blank">
              <div class="badge badge-info">{{ item.id }}</div>
            </a>

            <template v-else>
              {{ item.id }}
            </template>
          </template>

          <template v-slot:number="{item}">
            <span v-if="item.number">{{ item.number.phone }}</span>
          </template>

          <!--  RemoveMe: extra        -->

          <!--          <template v-slot:status="{item}">-->
          <!--            <div :class="item.status === 'success' ? 'badge-success' : 'badge-danger'" class="badge">-->
          <!--              {{ item.status === 'success' ? 'پرداخت شده' : 'عدم پرداخت' }}-->
          <!--            </div>-->
          <!--          </template>-->

          <!--          <template v-slot:send="{item}">-->
          <!--            {{ item.send || '-' }}-->
          <!--          </template>-->

          <!--          <template v-slot:delete="{item}">-->
          <!--            {{ item.delete || '-' }}-->
          <!--          </template>-->

          <template v-slot:auto_payments="{item}">
            <template v-if="item.auto_payments && item.auto_payments.length">
              <div v-for="(auto, i) in item.auto_payments" :key="i" class="badge badge-info">
                {{ auto.title }}
                <v-icon color="white" left small @click="deleteTag(item, i)">mdi-close</v-icon>
              </div>
            </template>

            <span v-else>-</span>
          </template>

          <template v-slot:action="{item}">
            <auto-pay-buttons :item="item" @click="() => {editValue = item; groupPayDialog = true}"/>
          </template>
        </vue-table>
      </v-col>
    </v-row>

    <custom-popup v-model="groupPayDialog" :cons="cons" max-width="600" reloadable>
      <auto-pay-dialog v-if="groupPayDialog" :code.sync="upgradeCode" :token="editValue.manage_token"/>
    </custom-popup>
  </div>
</template>

<script>
import AutoPayDialog from "@/view/pages/ads/adsList/autoPayDialog.vue";
import {Axios2} from "@/main";
import AutoPayButtons from "@/view/pages/ads/adsList/autoPayButtons.vue";

export default {
  name: "autoPayAds",

  components: {AutoPayButtons, AutoPayDialog},

  data() {
    return {
      selectedRows: [],
      groupPayDialog: false,
      data: {},
      loading: false,
      tableProps: {
        page: 1,
        length: 10
      },
      cons: {
        title: 'پرداخت آگهی',
        buttons: [
          {type: 'submit', handler: this.upgrade, disabled: () => !this.upgradeCode},
          {type: 'close', handler: this.clearUpgrade}
        ]
      },
      editValue: {},
      upgradeCode: null,
      headers: [
        {value: 'index', text: 'ردیف', sortable: false, align: 'center'},
        {value: 'id', text: 'شناسه آگهی', sortable: false, align: 'center'},
        {value: 'number', text: 'شماره', sortable: false, align: 'center'},
        {value: 'title', text: 'عنوان آگهی', sortable: false, align: 'center'},
        // {value: 'send', text: 'تاریخ ارسال', sortable: false, align: 'center'},
        // {value: 'delete', text: 'تاریخ حذف', sortable: false, align: 'center'},
        // {value: 'status', text: 'وضعیت', sortable: false, align: 'center'},
        {value: 'auto_payments', text: 'پرداخت‌ها', sortable: false, align: 'center'},
        {value: 'action', text: 'مدیریت', sortable: false, align: 'center'},
      ],
      items: [
        {value: 'divar', text: 'آگهی های شخصی'},
        {value: 'divar_shop', text: 'آگهی های فروشگاهی'},
        {value: 'divar_shop_pro', text: 'آگهی های فروشگاهی پرو'},
        {value: 'divar_real_estate', text: 'آگهی های پنل املاک'},
        {value: 'car_business', text: 'آگهی های نمایشگاه خودرو'},
      ],
      autoPayItems: [
        {value: 'empty', text: 'بدون پرداخت'},
        {value: 'steps', text: 'پله'},
        {value: 'gradual', text: 'نردبان'},
        {value: 'fory', text: 'فوری'},
        {value: 'foryGradual', text: 'فوری نردبان'},
        {value: 'tamdid', text: 'تمدید'},
        {value: 'tamdidGradual', text: 'تمدید نردبان'},
      ]
    }
  },

  mounted() {
    this.fetch()
  },

  methods: {
    fetch(params = this.tableProps) {
      this.loading = true

      Axios2.get('divar/auto/payment', {
        params
      })
        .then(({data}) => this.data = data)
        .catch(({response}) => {
          this.$toast.error('خطا در دریافت اطلاعات!')
          console.log('failed to get auto payment list: ', response)
        })
        .finally(() => this.loading = false)
    },
    payGroup() {
      this.groupPayDialog = true
      this.editValue = this.selectedRows[0]
    },
    onPaginate(e) {
      let props = {
        ...this.tableProps,
        ...e
      }

      this.fetch(props)
    },
    clearUpgrade() {
      this.upgradeCode = null
    },
    upgrade() {
      this.loading = true

      Axios2.post('divar/auto/payment', {
        title: this.upgradeCode?.title,
        code: this.upgradeCode?.slug,
        ids: !!this.selectedRows?.length
          ? this.selectedRows.map(item => item.id)
          : [this.editValue.id]
      })
        .then(({data}) => {
          this.$toast.success('پرداخت با موفقیت انجام شد.')
        })
        .catch(({response}) => {
          this.$toast.error('خطا در پرداخت اتوماتیک')
          console.log('failed to auto pay advertise: ', response)
        })
        .finally(() => this.loading = false)
    },
    async deleteTag(item, index) {
      // divar/auto/payment/{id}

      let tag = item.auto_payments[index]

      if (await this.$modal.yesNo(`حذف ${tag.title} خودکار ؟`)) {
        Axios2.delete(`divar/auto/payment/${tag.id}`)
          .then(({data}) => {
            this.$toast.success('با موفقیت ویرایش شد.')
            this.onPaginate()
          })
          .catch(({response}) => {
            console.log('failed to delete auto/payment tag: ', response)
            this.$toast.error('خطا در حذف پرداخت خودکار!')
          })
      }
    }
  }
}
</script>

<style scoped>

</style>